import { render, staticRenderFns } from "./consentDeclarationCard.vue?vue&type=template&id=6aa45ee5"
import script from "./consentDeclarationCard.vue?vue&type=script&lang=js"
export * from "./consentDeclarationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports